import React from 'react';

if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
  document.documentElement.classList.add('ios-safari');
}
import ReactDOM from 'react-dom/client';
import "./index.css";
import { Provider } from "react-redux";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter as Router } from "react-router-dom";
// import { configureStore } from './store';
import { persistor, store } from "./store";
import Storage from "@aws-amplify/storage";
import { PersistGate } from "redux-persist/lib/integration/react";

// if (!JSON.parse(import.meta.env.VITE_isOfflineMCU)) {
//   Amplify.configure({
//     Auth: {
//       mandatorySignIn: true,
//       region: config.JSON.parse(import.meta.env.VITE_cognito).REGION,
//       userPoolId: config.JSON.parse(import.meta.env.VITE_cognito).USER_POOL_ID,
//       identityPoolId: config.JSON.parse(import.meta.env.VITE_cognito).IDENTITY_POOL_ID,
//       userPoolWebClientId: config.JSON.parse(import.meta.env.VITE_cognito).APP_CLIENT_ID,
//     },
//     Storage: {
//       region: JSON.parse(import.meta.env.VITE_s3).REGION,
//       bucket: JSON.parse(import.meta.env.VITE_s3).PROFILEBUCKET,
//       identityPoolId: config.JSON.parse(import.meta.env.VITE_cognito).INVC_IDENTITY_POOL_ID,
//     },
//     API: {
//       endpoints: [
//         {
//           name: "insta",
//           endpoint: config.JSON.parse(import.meta.env.VITE_apiGateway).URL,
//           region: config.JSON.parse(import.meta.env.VITE_apiGateway).REGION,
//         },
//         {
//           name: "domain",
//           endpoint: config.JSON.parse(import.meta.env.VITE_apiDomainGateway).URL,
//           region: config.JSON.parse(import.meta.env.VITE_apiDomainGateway).REGION,
//         },
//         {
//           name: "mcu",
//           endpoint: config.JSON.parse(import.meta.env.VITE_apiMcuGateway).URL,
//           region: config.JSON.parse(import.meta.env.VITE_apiMcuGateway).REGION,
//         },
//         {
//           name: "user",
//           endpoint: config.JSON.parse(import.meta.env.VITE_apiUserGateway).URL,
//           region: config.JSON.parse(import.meta.env.VITE_apiUserGateway).REGION,
//         },
//         {
//           name: "plan",
//           endpoint: config.JSON.parse(import.meta.env.VITE_apiPlanGateway).URL,
//           region: config.JSON.parse(import.meta.env.VITE_apiPlanGateway).REGION,
//         },
//         {
//           name: "coupon",
//           endpoint: config.JSON.parse(import.meta.env.VITE_apiCouponGateway).URL,
//           region: config.JSON.parse(import.meta.env.VITE_apiCouponGateway).REGION,
//         },
//         {
//           name: "transaction",
//           endpoint: config.JSON.parse(import.meta.env.VITE_apiTransactionGateway).URL,
//           region: config.JSON.parse(import.meta.env.VITE_apiTransactionGateway).REGION,
//         },
//         {
//           name: "referral",
//           endpoint: config.JSON.parse(import.meta.env.VITE_apiReferralGateway).URL,
//           region: config.JSON.parse(import.meta.env.VITE_apiReferralGateway).REGION,
//         },
//         {
//           name: "recording",
//           endpoint: config.JSON.parse(import.meta.env.VITE_apiRecordingGateway).URL,
//           region: config.JSON.parse(import.meta.env.VITE_apiRecordingGateway).REGION,
//         },
//         {
//           name: "mcu_recording",
//           endpoint: config.JSON.parse(import.meta.env.VITE_apimcuRecordingGateway).URL,
//           region: config.JSON.parse(import.meta.env.VITE_apimcuRecordingGateway).REGION,
//         },
//         {
//           name: "content",
//           endpoint: config.JSON.parse(import.meta.env.VITE_apiContentGateway).URL,
//           region: config.JSON.parse(import.meta.env.VITE_apiContentGateway).REGION,
//         },
//         {
//           name: "schedule",
//           endpoint: config.JSON.parse(import.meta.env.VITE_apiScheduleGateway).URL,
//           region: config.JSON.parse(import.meta.env.VITE_apiScheduleGateway).REGION,
//         },
//         {
//           name: "address",
//           endpoint: config.JSON.parse(import.meta.env.VITE_apiAddressGateway).URL,
//           region: config.JSON.parse(import.meta.env.VITE_apiAddressGateway).REGION,
//         },
//         {
//           name: "multipart_upload",
//           endpoint: config.JSON.parse(import.meta.env.VITE_apiMultipartUploadGateway).URL,
//           region: config.JSON.parse(import.meta.env.VITE_apiMultipartUploadGateway).REGION,
//         },
//         {
//           name: "meetings",
//           endpoint: config.JSON.parse(import.meta.env.VITE_apiMeetingGateway).URL,
//           region: config.JSON.parse(import.meta.env.VITE_apiMeetingGateway).REGION,
//         },
//         {
//           name: "mail",
//           endpoint: config.JSON.parse(import.meta.env.VITE_apiMailGateway).URL,
//           region: config.JSON.parse(import.meta.env.VITE_apiMailGateway).REGION,
//         },
//         {
//           name: "broadcast",
//           endpoint: config.JSON.parse(import.meta.env.VITE_apiBroadcastGateway).URL,
//           region: config.JSON.parse(import.meta.env.VITE_apiBroadcastGateway).REGION,
//         },
//         {
//           name: "test",
//           endpoint: config.JSON.parse(import.meta.env.VITE_apiTestGateway).URL,
//           region: config.JSON.parse(import.meta.env.VITE_apiTestGateway).REGION,
//         },
//         {
//           name: "doc_share",
//           endpoint: config.JSON.parse(import.meta.env.VITE_apiDocumentShareGateway).URL,
//           region: config.JSON.parse(import.meta.env.VITE_apiDocumentShareGateway).REGION,
//         },
//         {
//           name: "chat",
//           endpoint: config.JSON.parse(import.meta.env.VITE_apiChatGateway).URL,
//           region: config.JSON.parse(import.meta.env.VITE_apiChatGateway).REGION,
//         },
//         {
//           name: "admin",
//           endpoint: config.JSON.parse(import.meta.env.VITE_apiAdminGateway).URL,
//           region: config.JSON.parse(import.meta.env.VITE_apiAdminGateway).REGION,
//         },
//         {
//           name: "inVCSchedule",
//           endpoint: config.JSON.parse(import.meta.env.VITE_invcScheduleAPI).URL,
//           region: config.JSON.parse(import.meta.env.VITE_invcScheduleAPI).REGION,
//         },
//         {
//           name: "inVCEmail",
//           endpoint: config.JSON.parse(import.meta.env.VITE_invcEmailAPI).URL,
//           region: config.JSON.parse(import.meta.env.VITE_invcEmailAPI).REGION,
//         },
//         {
//           name: "inVCLicense",
//           endpoint: config.JSON.parse(import.meta.env.VITE_invcLicenseAPI).URL,
//           region: config.JSON.parse(import.meta.env.VITE_invcLicenseAPI).REGION,
//         },
//         {
//           name: "class",
//           endpoint: config.JSON.parse(import.meta.env.VITE_apiClassCreateGateway).URL,
//           region: config.JSON.parse(import.meta.env.VITE_apiClassCreateGateway).REGION,
//         },
//         {
//           name: "inclassChat",
//           endpoint: config.JSON.parse(import.meta.env.VITE_inclassChatAPI).URL,
//           region: config.JSON.parse(import.meta.env.VITE_inclassChatAPI).REGION,
//         },
//         {
//           name: "inClassMcu",
//           endpoint: config.JSON.parse(import.meta.env.VITE_inclassMcuAPI).URL,
//           region: config.JSON.parse(import.meta.env.VITE_inclassMcuAPI).REGION,
//         },
//         {
//           name: "inClassReports",
//           endpoint: config.JSON.parse(import.meta.env.VITE_inclassReportsAPI).URL,
//           region: config.JSON.parse(import.meta.env.VITE_inclassReportsAPI).REGION,
//         },
//         {
//           name: "inClassAssessments",
//           endpoint: config.JSON.parse(import.meta.env.VITE_inclassAssessmentsAPI).URL,
//           region: config.JSON.parse(import.meta.env.VITE_inclassAssessmentsAPI).REGION,
//         },
//       ],
//     },
//   });
// }

export function SetS3Config(bucket, level) {
  Storage.configure({
    bucket: bucket,
    level: level,
    region: "ap-southeast-1",
    identityPoolId: JSON.parse(import.meta.env.VITE_cognito).IDENTITY_POOL_ID,
  });
}
global.store = store;

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <Router>
        <App store={store} />
      </Router>
    </PersistGate>
  </Provider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
